import { LinearProgress, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';

function LoadingEvent({ children = null, ...rest }) {
  return (
    <Grid2 container {...rest}>
      {children && (
        <Grid2 textAlign="center" sx={{ mb: 2 }} xs={10} xsOffset={1}>
          <Typography variant="h6" component="div">
            {children}
          </Typography>
        </Grid2>
      )}
      <Grid2 alignContent="center" xs={10} xsOffset={1}>
        <LinearProgress />
      </Grid2>
    </Grid2>
  );
}

export default LoadingEvent;
